
const digest = '5faac154a882c58d1e6f1f1175b3e6c724c6c8fd357aad7a949292cf77165b86';
const classes = {"actions":"_actions_6b0e2_1"};
const css = `._actions_6b0e2_1 {
  display: flex;
  gap: 7px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  